import { useLocalStorage } from "@src/appV2/lib/utils/useLocalstorage";
import { useEffect } from "react";

import { CbhFeatureFlag } from "../../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../../FeatureFlags/useCbhFlag";

const SURFACE_JOBS_CACHE_KEY = "surface-jobs-enabled";

export function useIsSurfaceJobsEnabled() {
  // We need to cache the feature flag value between startups to avoid race conditions on app start
  const [cachedValue, setCachedValue] = useLocalStorage<boolean>(SURFACE_JOBS_CACHE_KEY, false);
  const isSurfaceJobsEnabled = useCbhFlag(CbhFeatureFlag.SURFACE_JOBS, {
    defaultValue: cachedValue,
  });

  // Update the cache with the authoritative value
  useEffect(() => {
    setCachedValue(isSurfaceJobsEnabled);
  }, [isSurfaceJobsEnabled, setCachedValue]);

  return isSurfaceJobsEnabled;
}
